module.exports = __webpack_public_path__ + "img/userA03.80da4b1d.jpg";